export default function scrollToTop(): void {
  window.parent.postMessage({
    type: 'scroll-to',
    top: 0,
  }, '*');
}
